// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC__9iT1SJkuOKmOgCUyk9SDxI__D2p8yQ",
  authDomain: "cloudtree-f88e5.firebaseapp.com",
  projectId: "cloudtree-f88e5",
  storageBucket: "cloudtree-f88e5.firebasestorage.app",
  messagingSenderId: "182902130425",
  appId: "1:182902130425:web:d41d9943e83d179f378428",
  measurementId: "G-ZH8B86N0VH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app)
export const db = getFirestore(app,"cloudtreedatabase");
export const storage = getStorage(app);